import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import CustomerOrder from '~/containers/customerOrder/customerOrder';

export class CustomerOrderPage extends Component {
  state = {
    customer: null
  };

  onReceiveCustomer = ({ customer }) => {
    this.setState({
      customer
    });
  };

  render() {
    const customerId = this.props.match.params.customerId;
    const { customer } = this.state;

    const editButton = (
      <div className="flex">
        <Link to={`/customers/${customerId}`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar
          back={`/customers/${customerId}`}
          backText="Customer"
          title={customer ? customer.name : '...'}
          button={editButton}
        />
        <CustomerOrder onCompleted={this.onReceiveCustomer} id={customerId} />
      </Page>
    );
  }
}

export default withRouter(CustomerOrderPage);



// WEBPACK FOOTER //
// ./src/pages/customerOrder/customerOrder.jsx